<template>
	<!-- <el-menu  :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title" v-if="menu.show">
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <template v-for="chmenu in menu.menus" >
          <el-menu-item :index="'/'+chmenu.url" :key="chmenu.menuid" v-if="chmenu.show">
            <div >
              <i :class="chmenu.icon"></i>
              <span>{{chmenu.menuname}}</span>
            </div>
            
          </el-menu-item>
        </template>
        
      </el-menu-item-group>
    </el-submenu>
  </el-menu> -->
	<el-menu :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened
		class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b" @select="handleSelect">
		<div class="logobox">
			<!-- <div>北京天晟源</div> -->
			<!-- <img class="logoimg" src="../assets/img/logo.png" alt=""> -->
		</div>
		<div v-for="(menu,index) in $store.state.menuList" :key="index">


			<el-submenu :index="'id'+menu.id" v-show="menu.meta&& menu.meta.navVisible && menu.meta.navVisible=='yes'">
				<template slot="title">
					<i :class="menu.icon"></i>
					<span>{{menu.meta.title}}</span>
				</template>
				<el-menu-item-group>
					<template v-for="(chmenu,ind) in menu.children">
						<el-menu-item @click="consoleRoute(chmenu)" :index="'/'+chmenu.path" :key="ind"
							v-show="chmenu.meta && chmenu.meta.navVisible&& chmenu.meta.navVisible=='yes'">
							<div>
								<i :class="chmenu.icon"></i>
								<span>{{chmenu.meta.title}}</span>
							</div>

						</el-menu-item>
					</template>

				</el-menu-item-group>
			</el-submenu>
		</div>
	</el-menu>
</template>
<script>
	import {
		getUserMenu
	} from '../api/pemission'
	import {
		mapGetters
	} from 'vuex'
	// import store from '../store'
	export default {
		name: 'leftnav',
		data() {
			return {
				collapsed: false,
				allmenu: [],
				menuList1: []
			}
		},
		computed: {
			...mapGetters([
				'menuList'
			]),
			menuList() {
				return this.menuList
			},
		},
		// 创建完毕状态(里面是操作)
		created() {
			// this.getRoleMenu()
			// if(!this.$store.state.menuList.length){
			//     this.$store.commit('logout', 'false')
			//     this.$router.push({ path: '/login' })

			// }
			// 获取图形验证码
			let res = {
				success: true,
				data: [

					{
						menuid: 33,
						icon: 'el-icon-tickets',
						menuname: '订单管理',
						hasThird: null,
						url: null,
						show: 1,
						menus: [{
								menuid: 1,
								icon: 'el-icon-edit-outline',
								menuname: '订单管理',
								hasThird: 'N',
								url: 'order/order',
								menus: null,
								show: 1,
							},
							{
								menuid: 34,
								icon: 'el-icon-edit-outline',
								menuname: '评论管理',
								hasThird: 'N',
								url: 'order/ordercomments',
								menus: null,
								show: 1,
							}
						]
					},
					{
						menuid: 50,
						icon: 'el-icon-sell',
						menuname: '售后管理',
						hasThird: null,
						url: null,
						show: 1,
						menus: []
					},

				],
				msg: 'success'
			}
			this.allmenu = res.data

			// menu(localStorage.getItem('logintoken'))
			//   .then(res => {
			//     console.log(JSON.stringify(res))
			//     if (res.success) {
			//       this.allmenu = res.data
			//     } else {
			//       this.$message.error(res.msg)
			//       return false
			//     }
			//   })
			//   .catch(err => {
			//     this.$message.error('菜单加载失败，请稍后再试！')
			//   })
			// 监听
			this.$root.Bus.$on('toggle', value => {
				this.collapsed = !value
			})
		},
		methods: {
			handleSelect(val){
				console.log(val)
				// store.commit('selectMenu', val)
			},
			consoleRoute(val) {
				console.log(val)
			},
			getRoleMenu() {

				let uid = sessionStorage.getItem('uid')

				getUserMenu({
					uid
				}).then(response => {
					console.log(response)
					this.menuList1 = response.data;



				})
			}
		}
	}
</script>
<style>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 240px;
		min-height: 400px;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		border: none;
		text-align: left;
	}

	.el-menu-item-group__title {
		padding: 0px;
	}

	.el-menu-bg {
		background-color: #1f2d3d !important;
	}

	.el-menu {
		border: none;
	}

	.logobox {
		height: 40px;
		line-height: 40px;
		color: #9d9d9d;
		font-size: 20px;
		text-align: center;
		padding: 20px 0px;
	}

	.logoimg {
		height: 40px;
	}
</style>
